import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = `JARVIS | ${title}`;
  }, [title]);
};

export default useDocumentTitle;
